// extracted by mini-css-extract-plugin
export default {"container":"NZ-z","list":"OZ-z"};